module.exports = " <div> <div class=illustration> <img v-bind:src=src role=presentation> <div class=body> <p> <slot name=title></slot> </p> <p> <slot name=desc></slot> </p> <button v-if=show class=\"btn secondary\">{{text}}</button> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/illustration.vue
// module id = 136
// module chunks = 1